import React from 'react';
import { useSelector } from 'react-redux';
import FormMultiSelect from 'shared/formControls/FormMultiSelect';
import FormSelect from 'shared/forms/FormSelect';
import { getActivityTypes } from 'src/slices/activityTypes';

const ActivityTypeDropdown = (props) => {

    const activityTypes = useSelector(getActivityTypes);
    const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;
    const value = typeof props.value === 'object' ? props.value : activityTypes.find(x => x.value == props.value);

    return (
        <SelectComponent
            data={activityTypes}
            dataItemKey={props.dataItemKey || 'value'}
            textField={props.textField || 'description'}
            clearButton={true}
            {...props}
            value={value}
        />
    );
};

export default ActivityTypeDropdown;